<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="customer.pkid ? '编辑' : '新建'"
        class="customer-edit"
        width="700px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="customer"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="客户" prop="customerId">
          <el-input :value="customer.customerName" disabled placeholder="请选择客户">
            <el-button
                v-if="!customer.pkid"
                slot="append"
                icon="el-icon-search"
                @click="$refs.customerSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="省市区">
              <vm-district-select v-model="customer.areaId"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="街道">
              <el-select v-model="customer.streetName" clearable placeholder="请选择">
                <el-option
                    v-for="item in lastDistrict"
                    :key="item.districtID"
                    :label="item.districtName"
                    :value="item.districtName"
                    @click.native="selectLastDistrictName(item)"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详细地址" prop="addressDetail">
          <el-input v-model="customer.addressDetail"/>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="customer.contact" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="customer.telephone" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="默认地址">
          <el-radio-group v-model="customer.isDefault">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="customer.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <div class="section-title">附件上传</div>
      <div>
        <el-upload
            action=""
            multiple
            :http-request="submitUpload"
            :show-file-list="false"
            :disabled="uploadLoading"
            style="display: inline-block; margin: 5px;">
          <el-button type="primary" plain>
            <i class="el-icon-upload el-icon--right"/>
            附件上传
          </el-button>
        </el-upload>
      </div>
      <el-table v-if="customer.accessoryVoList && customer.accessoryVoList.length" ref="payData" border :data="customer.accessoryVoList">
        <el-table-column type="index" align="center" label="行号" width="60"/>
        <el-table-column prop="fileName" align="center" label="附件名称"/>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="fileDelete(scope.$index)">删除</el-button>
            <el-button type="primary" size="mini" @click="fileDownload(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <customer-select ref="customerSelect" @select="onSelectCustomer"/>
  </div>
</template>

<script>
  import VmDistrictSelect from "@/components/VmDistrictSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "CustomerDeliveryAddressEdit",
    components: {VmDistrictSelect, CustomerSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        lastDistrict: [],
        customer: {
          pkid: "",
          customerId: "",
          customerName: "",
          streetId: 0,//街道id
          areaId: 0,//区域id
          districtId: 0,//街道id
          addressName: "",
          streetName: "",
          addressDetail: "",
          contact: "",
          telephone: "",
          note: "",
          isDefault: false,
          isDeleted: "",
          accessoryVoList: [],
        },
        ruleValidate: {
          customerId: {required: true, message: "不能为空", trigger: "change"},
          addressDetail: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    watch: {
      "customer.areaId": {
        deep: true,
        handler: function(newVal, oldVal) {
          if (newVal !== oldVal) {
            if (oldVal !== 0) {
              this.customer.streetName = "";
              this.customer.streetId = "";
            }
            this.getLastDistrict(newVal);
          }
        },
      },
    },
    methods: {
      open(row) {
        this.resetForm();
        if (row) {
          this.customer.pkid = row.pkid;
          this.getData();
        }
        this.dialogVisible = true;
      },
      resetForm() {
        this.customer = {
          pkid: "",
          customerId: "",
          customerName: "",
          streetId: 0,
          areaId: 0,
          districtId: 0,
          addressName: "",
          streetName: "",
          addressDetail: "",
          contact: "",
          telephone: "",
          note: "",
          isDefault: false,
          isDeleted: "",
          accessoryVoList: [],
        };
        this.lastDistrict = [];
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `customerDeliveryAddress/${this.customer.pkid}`)
          .then(resp => {
            this.contentLoading = false;
            Object.assign(this.customer, resp);
            this.customer.accessoryVoList = resp.accessoryVoList || [];
            this.getLastDistrict(this.customer.streetId);
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },
      getLastDistrict(id) {
        if (id > 0) {
          this.contentLoading = true;
          this.$http
            .get("basic", `districts/getDistrictListByParentId/${id}`)
            .then(resp => {
              this.lastDistrict = resp;
              this.contentLoading = false;
            }).catch(() => {
              this.contentLoading = false;
              this.$message.error("获取街道数据失败");
            });
        }
      },
      selectLastDistrictName(item) {
        this.customer.streetName = item.districtName;
        this.customer.streetId = item.districtID;
      },
      onSelectCustomer(row) {
        this.customer.customerId = row.customerID;
        this.customer.customerName = row.customerName;
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            const {success, data} = res || {};
            if (success) {
              this.uploadLoading = false;
              const fileInfo = data.attachments[0];
              if (!this.customer.accessoryVoList) {
                this.customer.accessoryVoList = [];
              }
              this.customer.accessoryVoList.push({
                fileName: fileInfo.fileName,
                filePath: "/attached/file/" + fileInfo.filePath,
                itemType: 100,
                fileData: fileInfo.fileByte,
              });
              this.$message.success("上传成功");
            }
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      fileDelete(index) {
        this.customer.accessoryVoList.splice(index, 1);
      },
      fileDownload(row) {
        const filePath = row.filePath || "";
        const fileName = row.fileName || "";
        const str = filePath.slice(0, 1);
        // ~ 或 / 开头表示文件服务器上的相对路径（如 ~xxx、/attached/file/xxx），
        // 直接拼 fileServerUrl 直链下载，不能作为 uuid 传给 file/download 接口
        if (str === "~" || str === "/") {
          let base = window.config.fileServerUrl || "";
          if (base.endsWith("/")) {
            base = base.slice(0, -1);
          }
          let cleanPath = filePath.replace(/^~+/, "").replace(/^\/+/, "");
          let a = document.createElement("a");
          a.href = base + "/" + cleanPath;
          a.target = "_blank";
          a.download = fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          let data = {
            name: row.fileName,
            uuid: row.filePath,
          };
          this.$http
            .exportFile("basic", "file/download", data)
            .then((res) => {
              let blob = new Blob([res.data], {type: "application"});
              let fileName = decodeURI(res.config.params.name);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
            })
            .catch(() => {
              this.$message.error("下载失败");
            });
        }
      },
      handleSubmit() {
        if (this.customer.streetName === "" || this.customer.streetName == null) {
          this.customer.streetId = 0;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            const request = this.customer.pkid
              ? this.$http.put("basic", "customerDeliveryAddress", this.customer)
              : this.$http.post("basic", "customerDeliveryAddress", this.customer);
            request
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 14px;
  font-weight: bold;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
</style>
